import { EntityType } from 'types/entityType';
import { DraftStatus } from 'utils/statuses';

export const getEntityTitle = (entityType: EntityType, status?: DraftStatus | string) => {
  const isDraft = status && Object.values(DraftStatus).includes(status as DraftStatus);
  if (isDraft) return 'Draft';

  switch (entityType) {
    case EntityType.FRAME:
      return 'Frame';
    case EntityType.LINKED_ASSET:
      return 'Linked Asset';
    default:
      return '';
  }
};
